import { render, staticRenderFns } from "./CopyrightApplications.vue?vue&type=template&id=87a942a8&scoped=true&"
import script from "./CopyrightApplications.vue?vue&type=script&lang=js&"
export * from "./CopyrightApplications.vue?vue&type=script&lang=js&"
import style0 from "./CopyrightApplications.vue?vue&type=style&index=0&id=87a942a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87a942a8",
  null
  
)

export default component.exports